import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { OrderAPI } from "../../lib/API";
import TicketsAPI from "../../lib/API/TicketsAPI";
import Utils from "../../lib/Utils";

const TicketForm = () => {

    const isLoggedIn = Utils.CheckUser();
    const history = useHistory();
    const queryParams = new URLSearchParams(history.location.search);

    const getDefaultType = () => {
        if (queryParams.get('brand'))
            return "PurchaseProblem"
        if (queryParams.get('order'))
            return "UndeliveredProduct"
        return ""
    }

    const [ticket, setTicket] = useState({
        title: "",
        type: getDefaultType(),
        order: queryParams.get('order'),
        brand: queryParams.get('brand'),
        brandName: queryParams.get('brandName'),
        productId: queryParams.get('productId'),
        content: "",
    });

    const [selectedOrder, setSelectedOrder] = useState();
    const [myOrders, setMyOrders] = useState();

    useEffect(() => {
        if (!isLoggedIn) return
        OrderAPI.GetMyOrders(-1)
            .then(({ data }) => {
                console.log(ticket.order);
                setMyOrders(data)
                if (ticket.order)
                    setSelectedOrder(data.find(o => o.id == ticket.order));
            });
    }, [])

    const onChange = ({ target }) => {
        setTicket({ ...ticket, [target.name]: target.value })
    }

    const onOrderSelect = ({ target }) => {
        setTicket({ ...ticket, [target.name]: target.value })
        setSelectedOrder(myOrders.find(o => o.id == target.value));
    }

    const onSubmit = (e) => {
        e.preventDefault();
        TicketsAPI.createTicket(ticket)
            .then(() => history.push('/support/mytickets'))
            .catch(() => alert('An error occured'));
    }

    return (
        <>
            <div className="products-search ">
                <h3>Support</h3>
                {isLoggedIn && (
                    <div className="d-flex justify-content-center align-items-center">
                        <Link to={"/support"} className="h4">New ticket</Link>
                        <span className="h5"> | </span>
                        <Link to={"/support/mytickets"} className="h5">My Tickets</Link>
                    </div>
                )}
            </div>
            <div className="container mt-5">
                <h2 className="text-center open-font-condensed mb-5">Create a new support ticket</h2 >
                <div className="row">
                    <div className="col-6 offset-3">
                        {isLoggedIn ? (

                            <form onSubmit={onSubmit}>
                                <div className="form-group">
                                    <label for="title">Title</label>
                                    <input className="form-control form-control-lg" type="text" name="title" onChange={onChange} />
                                </div>
                                <div className="form-group">
                                    <label for="subject">Topic</label>
                                    <select className="form-control select select-lg open-font-condensed" name="type" defaultValue={ticket.type} onChange={onChange}>
                                        <option value="">Select topic</option>
                                        <option value="PurchaseProblem">Problem purchasing a product</option>
                                        <option value="UndeliveredProduct">Didn't receive product</option>
                                        <option value="PaymentProblem">I have a problem with payment</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                {ticket.brand && (
                                    <div className="form-group">
                                        <label for="subject">Product</label>
                                        <input className="form-control form-control-lg" type="text" name="brand" defaultValue={ticket.brandName} disabled />
                                    </div>
                                )}
                                {(ticket.order != null || ticket.type == 'UndeliveredProduct') && !ticket.brand && (
                                    <>
                                        <div className="form-group">
                                            <label for="subject">Order</label>
                                            {myOrders && (
                                                <select className="form-control select select-lg open-font-condensed" name="order" defaultValue={ticket.order} onChange={onOrderSelect}>
                                                    <option value="">Select order</option>
                                                    {myOrders && myOrders.map((o) => (
                                                        <option key={o.id} value={o.id}>{o.label}</option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label for="subject">Product</label>
                                            {selectedOrder && (
                                                <select className="form-control select select-lg open-font-condensed" name="productId" defaultValue={ticket.productId} onChange={onChange}>
                                                    <option value="">All products</option>
                                                    {selectedOrder && selectedOrder.items && selectedOrder.items.map((i) => (
                                                        <option key={i._id} value={i._id}>{i.name}</option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                    </>
                                )}
                                <div className="form-group">
                                    <label for="message">Message</label>
                                    <textarea className="form-control form-control-lg" rows={5} name="content" onChange={onChange}
                                        placeholder="Can you explain your problem?">

                                    </textarea>
                                </div>
                                <div className="form-group text-center">
                                    <button className="btn-black btn-lg">SUBMIT TICKET</button>
                                </div>
                            </form>
                        ) : (
                            <div className="text-center p-5">
                                <h3 className="mb-3">Your have to be logged in to be able to create a ticket</h3>
                                <Link to={'/auth'} className="btn btn-black">Login</Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export { TicketForm };